/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CareerSiteSettingResponse } from '../models/CareerSiteSettingResponse';
import type { UpdateCareerSiteSettingParams } from '../models/UpdateCareerSiteSettingParams';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CareerSiteService {

    /**
     * brand configuration
     * @param careerSite Career Site Params
     * @returns any successful
     * @throws ApiError
     */
    public static getInternalApiCareerSiteBrandsConfiguration(
        careerSite: {
            account_slug: string;
            brand_id?: string;
            locale?: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal_api/career_site/brands/configuration',
            query: {
                'career_site': careerSite,
            },
        });
    }

    /**
     * list locations
     * @param careerSite Career Site Params
     * @param query Search locations by name (case-insensitive)
     * @param page Page number for pagination
     * @param perPage Number of items per page
     * @param skipPagination Skip pagination
     * @returns any successful
     * @throws ApiError
     */
    public static getInternalApiCareerSiteLocations(
        careerSite: {
            account_slug: string;
            brand_id?: string;
        },
        query?: string,
        page?: number,
        perPage?: number,
        skipPagination?: boolean,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal_api/career_site/locations',
            query: {
                'career_site': careerSite,
                'query': query,
                'page': page,
                'per_page': perPage,
                'skip_pagination': skipPagination,
            },
        });
    }

    /**
     * list openings
     * @param careerSite Career Site Params
     * @param radius Distance Radius
     * @param sortBy Sorting param
     * @param category Category Name
     * @param compensationType Compensation Type
     * @param page Pagination defaults to 0
     * @param query Search string
     * @param department Search Depaartment
     * @param location Location filter (all, current_location, or a location external_id). Defaults to all when omitted.
     * @param position Search Position
     * @param locale Target locale for translation
     * @returns any successful
     * @throws ApiError
     */
    public static getInternalApiCareerSiteOpenings(
        careerSite: {
            account_slug: string;
            brand_id?: string;
            position_id?: string;
            location_id?: string;
            experience_level?: string;
            place_id?: string;
            is_jobs_from_current_location?: boolean;
        },
        radius: string,
        sortBy: string,
        category: string,
        compensationType: string,
        page?: number,
        query?: string,
        department?: string,
        location?: string,
        position?: string,
        locale?: 'af-ZA' | 'sq-AL' | 'am-ET' | 'ar' | 'hy-AM' | 'az-AZ' | 'bn-IN' | 'bs-BA' | 'bg-BG' | 'ca' | 'zh-CN' | 'zh-HK' | 'zh-TW' | 'hr-HR' | 'cs-CZ' | 'da-DK' | 'fa-AF' | 'nl-NL' | 'en-GB' | 'en-US' | 'et-EE' | 'fa-IR' | 'fi-FI' | 'fr-FR' | 'fr-CA' | 'ka-GE' | 'de-DE' | 'el-GR' | 'gu-IN' | 'ht-HT' | 'ha' | 'he-IL' | 'hi-IN' | 'hu-HU' | 'id-ID' | 'it-IT' | 'ja-JP' | 'kn-IN' | 'kk-KZ' | 'ko-KR' | 'lv-LV' | 'lt-LT' | 'mk-MK' | 'ms-MY' | 'ml-IN' | 'mr-IN' | 'mn-MN' | 'no-NO' | 'ps' | 'pl-PL' | 'pt-BR' | 'pt-PT' | 'pa-IN' | 'ro-RO' | 'ru-RU' | 'sr-RS' | 'si-LK' | 'sk-SK' | 'sl-SI' | 'so' | 'es-ES' | 'es-MX' | 'sw' | 'sv-SE' | 'tl-PH' | 'ta-IN' | 'te-IN' | 'th-TH' | 'tr-TR' | 'uk-UA' | 'ur' | 'uz-UZ' | 'vi-VN',
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal_api/career_site/openings',
            query: {
                'career_site': careerSite,
                'page': page,
                'radius': radius,
                'sort_by': sortBy,
                'category': category,
                'compensation_type': compensationType,
                'query': query,
                'department': department,
                'location': location,
                'position': position,
                'locale': locale,
            },
        });
    }

    /**
     * list positions
     * @param careerSite Career Site Params
     * @param query Search positions by name (case-insensitive)
     * @param page Page number for pagination
     * @param perPage Number of items per page
     * @param skipPagination Skip pagination
     * @param locale Locale
     * @returns any successful
     * @throws ApiError
     */
    public static getInternalApiCareerSitePositions(
        careerSite: {
            account_slug: string;
            brand_id: string;
        },
        query?: string,
        page?: number,
        perPage?: number,
        skipPagination?: boolean,
        locale?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal_api/career_site/positions',
            query: {
                'career_site': careerSite,
                'query': query,
                'page': page,
                'per_page': perPage,
                'skip_pagination': skipPagination,
                'locale': locale,
            },
        });
    }

    /**
     * list positions categories
     * @param careerSite Career Site Params
     * @param query Search categories by name (case-insensitive)
     * @param page Page number for pagination
     * @param perPage Number of items per page
     * @param skipPagination Skip pagination
     * @returns any successful
     * @throws ApiError
     */
    public static getInternalApiCareerSitePositionsCategories(
        careerSite: {
            account_slug: string;
            brand_id?: string;
        },
        query?: string,
        page?: number,
        perPage?: number,
        skipPagination?: boolean,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal_api/career_site/positions/categories',
            query: {
                'career_site': careerSite,
                'query': query,
                'page': page,
                'per_page': perPage,
                'skip_pagination': skipPagination,
            },
        });
    }

    /**
     * list positions experience levels
     * @param careerSite Career Site Params
     * @returns any successful
     * @throws ApiError
     */
    public static getInternalApiCareerSitePositionsExperienceLevels(
        careerSite: {
            account_slug: string;
            brand_id: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal_api/career_site/positions/experience_levels',
            query: {
                'career_site': careerSite,
            },
        });
    }

    /**
     * list funnel by location
     * @param careerSite Career Site Params
     * @param query search query
     * @param locale locale for translated search
     * @returns any successful
     * @throws ApiError
     */
    public static getInternalApiCareerSiteSearchFunnelsByLocation(
        careerSite: {
            account_slug: string;
            brand_id?: string;
        },
        query?: string,
        locale?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal_api/career_site/search/funnels_by_location',
            query: {
                'career_site': careerSite,
                'query': query,
                'locale': locale,
            },
        });
    }

    /**
     * Returns career_site setting details
     * @param brandId Brand Id
     * @returns CareerSiteSettingResponse successful
     * @throws ApiError
     */
    public static getInternalApiCareerSiteSettings(
        brandId: string,
    ): CancelablePromise<CareerSiteSettingResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal_api/career_site/settings',
            query: {
                'brand_id': brandId,
            },
        });
    }

    /**
     * Updates career_site settings
     * @param brandId Brand external_id
     * @param requestBody Updates career_site settings
     * @returns CareerSiteSettingResponse successful
     * @throws ApiError
     */
    public static putInternalApiCareerSiteSettings(
        brandId: string,
        requestBody: UpdateCareerSiteSettingParams,
    ): CancelablePromise<CareerSiteSettingResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/internal_api/career_site/settings/{brand_id}',
            path: {
                'brand_id': brandId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}